
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.143 20H6.857C3.07 20 0 17.314 0 14c0-2.702 2.041-4.987 4.848-5.738A5.749 5.749 0 014.57 6.5C4.571 2.91 7.897 0 12 0c2.974 0 5.54 1.529 6.726 3.737A6.305 6.305 0 0121.714 3c3.156 0 5.715 2.239 5.715 5 0 .113-.005.226-.013.337C30.086 9.158 32 11.383 32 14c0 3.314-3.07 6-6.857 6z","fill":"#4F9BF3"}})])
          )
        }
      }
    